import { ArrowUpRight } from 'lucide-react';
import PropTypes from 'prop-types';
import React from 'react';

import { CORTEX_ASK_LABEL } from '../../cortexLinks';
import styles from './CortexLink.module.scss';

/**
 * Deep-link card that opens Cortex in a new tab with the task situation already
 * prefilled and submitted. Same idiom as AthenaLink and PlatformLink. The href
 * is built by buildCortexAskUrl, which returns null whenever no identifier-free
 * message can be formed — render nothing rather than a disabled card, so the
 * operator is never offered an action that cannot work.
 */
const CortexLink = ({ href, label, line }) => {
  if (!href) return null;

  if (line) {
    return (
      <a
        className={styles.line}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={label}
      >
        Cortex
        <ArrowUpRight size={14} aria-hidden="true" />
      </a>
    );
  }

  return (
    <a className={styles.link} href={href} target="_blank" rel="noopener noreferrer">
      <div className={styles.badge} aria-hidden="true">
        <span className={styles.badgeText}>C</span>
      </div>
      <div className={styles.meta}>
        <span className={styles.title}>{label}</span>
      </div>
      <span className={styles.arrow} aria-hidden="true">
        ↗
      </span>
    </a>
  );
};

CortexLink.propTypes = {
  href: PropTypes.string,
  label: PropTypes.string,
  line: PropTypes.bool,
};

CortexLink.defaultProps = {
  href: null,
  label: CORTEX_ASK_LABEL,
};

export default CortexLink;
